:host {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--color-bg-primary);
  color: var(--color-text-primary);
}
.header {
  display: flex;
  justify-content: space-between;
  padding: var(--padding-xl) var(--margin-xl);
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.notice {
  display: block;
  align-self: center;
  width: 100%;
  max-width: 40rem;
  margin: 0;
  padding: 30px;
  background: var(--color-warning);
  color: var(--color-text-dark);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
}
.notice h3 {
  font-size: 32px;
  text-align: center;
  margin: 0;
}
.logo {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
}
.nav-link {
  color: var(--color-text-primary);
  text-decoration: none;
  padding: var(--padding) var(--padding-xl);
  border-radius: var(--border-radius);
  border: var(--border);
}
.nav-link:hover {
  background: var(--color-text-secondary);
}
.hero {
  text-align: center;
  padding: 6rem 2rem;
  max-width: 800px;
  margin: 0 auto;
}
h1 {
  font-size: var(--font-size-xxl);
  font-weight: var(--font-weight-bold);
  margin: 0 0 var(--margin-xl);
  line-height: 1.2;
}
.subtitle {
  font-size: var(--font-size-l);
  opacity: 0.9;
  margin: 0 0 var(--margin-xl);
  line-height: 1.6;
}
.cta {
  display: inline-block;
  padding: var(--padding-xl) var(--margin-xl);
  background: var(--color-bg-primary);
  color: var(--color-bg-accent);
  text-decoration: none;
  border-radius: var(--border-radius);
  font-weight: var(--font-weight-medium);
  font-size: var(--font-size-l);
  transition:
    transform 0.2s,
    box-shadow 0.2s;
}
.cta:hover {
  transform: translateY(-2px);
  box-shadow: var(--box-shadow);
}
section .header {
  display: block;
  text-align: center;
  padding: 4rem 2rem 2rem 2rem;
}
section .header h2 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
  margin: 0 0 var(--margin);
}
.features,
.plans,
.badges {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 4rem 2rem;
  max-width: 1000px;
  margin: 0 auto;
}
.feature,
.plan,
.badge {
  background: var(--color-bg-secondary);
  padding: var(--margin-xl);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  text-align: center;
}
.plan {
  min-height: 300px;
  margin-bottom: 0;
}
.plan a.btn {
  display: inline-block;
  position: relative;
  margin-top: calc(var(--margin-xl) * 2.5);
  margin-bottom: 0;
  margin-left: auto;
  margin-right: auto;
}
.plan .price {
  font-size: var(--font-size-l);
  font-weight: var(--font-weight-bold);
  margin: var(--margin) 0 var(--margin-l) 0;
  color: var(--color-text-accent);
}
.feature-icon,
.plan-icon {
  font-size: var(--font-size-xxl);
  margin-bottom: var(--margin-xl);
}
.feature h3,
.plan h3,
.badge h3 {
  margin: 0 0 var(--margin);
  font-size: var(--font-size-xl);
}
.feature p,
.plan p,
.badge p {
  margin: 0;
  opacity: 0.8;
  font-size: var(--font-size);
}
.feature ul li,
.plan ul li {
  margin-bottom: var(--margin-s);
  font-size: var(--font-size);
  text-align: left;
}
.feature ul,
.plan ul {
  list-style: none;
  padding: 0;
  margin: var(--margin-l) 0 0 0;
}
.contact-form-container {
  max-width: 600px;
  margin: 0 auto;
  padding: calc(var(--margin-xl) * 2);
  background: var(--color-bg-primary);
  border-radius: var(--border-radius);
  border: var(--border);
  box-shadow: var(--box-shadow);
}
.contact-form {
  max-width: 600px;
  margin: 0 auto;
}
.contact-status {
  margin: 0 0 var(--margin);
  font-size: var(--font-size-s);
}
.contact-error {
  color: var(--color-danger);
}
.contact-success {
  color: var(--color-success);
}
.contact-form button[disabled] {
  opacity: 0.7;
  cursor: not-allowed;
}
.footer {
  text-align: center;
  padding: var(--margin-xl);
  margin: var(--margin-xxl) 0 0 0;
  opacity: 0.7;
  font-size: var(--font-size-s);
}

@media (max-width: 768px) {
  .logo {
    font-size: var(--font-size-l);
  }

  .hero {
    padding: 3rem var(--padding-l);
  }

  h1 {
    font-size: var(--font-size-xl);
  }

  .subtitle {
    font-size: var(--font-size);
  }

  .cta {
    padding: var(--padding-l) var(--padding-xl);
    font-size: var(--font-size);
  }

  section .header {
    padding: 2rem var(--padding-l);
    margin: 0 var(--margin-xl);
  }

  section .header h2 {
    font-size: var(--font-size-l);
  }

  .features,
  .plans,
  .badges {
    grid-template-columns: 1fr;
    gap: var(--padding-xl);
    padding: var(--padding-xl);
    margin: var(--margin-xl);
  }

  .feature,
  .plan,
  .badge {
    padding: var(--padding-xl);
    margin: var(--margin-xl) 0;
  }

  .contact-form-container {
    padding: var(--padding-xl);
    margin: 0 var(--margin-xxl);
  }

  .footer {
    padding: var(--padding-xl);
    margin: var(--margin-xxl) 0 0 0;
  }
}
